<script>
    import Image from '@project/components/Image.svelte'
    import { spring } from 'svelte/motion'
    import { dim } from '@project/utils'

    let urlPrefix = "/roxerdigital/404/";

    let w = dim().w
    let h = dim().h

    let el
    let c = spring({ x: 0, y: 0, x2: w, y2: -h }, {
        stiffness: 0.1,
        damping: 0.3
    })


    $: width = w;
    $: height = h;

    const load = (e) => {
        el = e.detail
        calcPolygon(e.detail)
    }

    const resize = () => {
        calcPolygon(el)
    }

    const calcPolygon = (element) => {
        if (!element) return

        setTimeout(() => {
            w = dim().w
            h = dim().h

            const { left, top, width, height } = element.getBoundingClientRect()

            c.set({
                x: left + width / 6,
                y: top + height / 4,
                x2: (left + width / 6) + width * 0.6,
                y2: (top + height / 4) + height / 3
            })
        }, 60)
    }
</script>

<svelte:head>
    <style>
        html,
        body {
            height: 100%;
        }

        body {
            background: #f5f4f6;
        }
    </style>
</svelte:head>

<svelte:window on:scroll={resize} on:resize={resize}></svelte:window>

<main class="h-full flex flex-col">
    <svg class="fixed -z-1" height="100%" width="100%">
        <polygon points="{$c.x} {$c.y} {$c.x2} {$c.y2} {width * 1.2} {height} {-1000} {height}" style="fill:#222;" />
    </svg>

    <header class="flex flex-col items-center mt-4">
        <img class="img" src="{urlPrefix}media/tesla_4.svg">
        <img class="mt-4 img" src="{urlPrefix}media/tesla_line.svg">
        <div class="w-1/2 max-w-lg">
            <Image on:load={load} height="270" jpg="{urlPrefix}media/Tesla_poster.jpg" mp4="{urlPrefix}media/Tesla_404.mp4"
                webm="{urlPrefix}media/Tesla_404.webm" />
        </div>
        <img class="mb-4 img" src="{urlPrefix}media/tesla_line.svg">
        <img class="img" src="{urlPrefix}media/tesla_4.svg">
    </header>
    <section style="text-shadow: 1px 1px 1px rgba(148, 90, 90, 0.40);"
        class="fix text-center py-12 text-xl font-sans leading-loose relative z-10 text-white flex flex-col h-full">
        <p class="pr-6 md:pr-24">
            EZ MOST NEM JÖTT ÖSSZE.
        </p>
        <p class="text-roxeryellow pl-6 md:pl-24">
            TALÁN MAJD LEGKÖZELEBB!
        </p>
    </section>
    <footer class="text-center pb-4">
        <a class="inline-block" href="https://roxer.hu/">
            <img alt="A Roxer logója" class="w-8 md:w-12" src="{urlPrefix}media/roxer_logo.png">
        </a>
    </footer>
</main>

<style>
    @supports (-webkit-overflow-scrolling: touch) {
        .fix {
            margin-top: 10em;
        }
    }

    .img {
        @apply w-12 inline-block;
    }

    @screen sm {
        .img {
            @apply w-16;
        }
    }

    @screen md {
        .img {
            @apply w-20;
        }
    }
</style>